export default "__VITE_ASSET__D49muJ2X__"